<div class="modal-header">
	<h3 class="modal-title">Domestic Project Tagging</h3>
	<div class="header-actions">
		<i class="fa"
			[ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
			style="margin-right: 10px; cursor: pointer;"
			(click)="minimise=!minimise"></i>
		<i (click)="modalClose()" class="fa fa-times" style="cursor: pointer;"></i>
	</div>
</div>

@if (isModalLoading) {
<mat-progress-bar color="primary" mode="indeterminate">
</mat-progress-bar>
}

@if (!isModalLoading) {
<div class="modal-body" [hidden]="minimise">
	<div class="panel-body">
		@if (!tableLoadingData) {
<mat-progress-bar color="primary" mode="indeterminate">
		</mat-progress-bar>
}

		@if (tableData) {
<div>
			<div class="divShadow1">
				<div class="table table-bordered table-condensed table-hover boldText" style="border:none;">
					<ap-table #basicTable [data]="SavedData" [striped]="true">
						<table>
        <caption class="sr-only">Domestic project tagging</caption>
							<thead class="a-thead">
								<tr>
									<th colspan="6"> Edit Project Tag
										@if (!FirstDiv) {
<i class="fa fa-plus-square color-white fa-lg pull-right"
											style="cursor: pointer; margin-top: 9px;" (click)="onClick()"></i>
}
										@if (FirstDiv) {
<i class="fa fa-plus-square color-white fa-lg pull-right"
											style="cursor: pointer; margin-top: 9px;" (click)="onClick()"></i>
}
									</th>
								</tr>
							</thead>
							@if (FirstDiv) {
<tbody class="a-tbody tbody-regular tbody-hover">
								<tr>
									<td style="background-color: #f5f5f5; text-align: center !important;"><b>Project Tag</b></td>
									<td style="background-color: #f5f5f5; text-align: center !important;"><b>Project Tag Amount</b></td>
									<td style="background-color: #f5f5f5; text-align: center !important;"><b>Action</b></td>
								</tr>
								@for (item of basicTable.data; track $index; let i = $index) {
<tr>
									<td style="text-align: center !important">{{item.PROJECT_NAME}}</td>
									<td style="text-align: center !important">
										<input type="number" [(ngModel)]="item.PROJECT_AMT"
											style="text-align: right !important;border: 1px solid lightgrey;">
									</td>
									<td style="text-align: center !important">
										<button type="button" (click)="deleteRecord(item.SEQUENCE_KEY)" class="btn btn-xs btn-danger" style="line-height: 0px;">
											<span class="fa fa-times"></span>
										</button>
									</td>
								</tr>
}
							</tbody>
}
						</table>
					</ap-table>
				</div>
			</div>
		</div>
}

		<div class="addNewTable">
			@if (TwoDiv) {
<table class="table table-bordered text">
				<thead>
					<tr>
						<th>Project Tag</th>
						<th>Project Tag Amount</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					@for (row of rows; track $index; let index = $index) {
<tr>
						<td>
							<div class="p-3 ProjectTaggingDropdown">
								<ap-dropdown class="field-full-width" [list]="row.projectList" [selectType]="'single'"
									[title]="'Project Tag'" [hideTitleOnInput]="true" [inputAriaLabel]="'Project Tag'"
									[(ngModel)]="row.selectedProjectItem" (onSelect)="onRowProjectSelect($event, row)">
									@for (item of row.projectList; track $index) {
										<ap-dropdown-list-item #dropdownListItem [item]="item"
											[ariaLabel]="setDropdownAriaLabel(item, 'Project Tag')"
											(onSelectItem)="onRowProjectSelectItem($event, row)"></ap-dropdown-list-item>
									}
								</ap-dropdown>
							</div>
						</td>
						<td>
							<div class="p-3 ProjectTaggingDropdown">
								<input type="number" [(ngModel)]="row.PROJECT_AMT" class="numberRecord">
							</div>
						</td>
						<td>
							<div class="p-3 ProjectTaggingDropdown">
								<button type="button" (click)="deleteRow(index)" class="btn btn-xs btn-danger" style="line-height: 0px;">
									<span class="fa fa-times"></span>
								</button>
							</div>
						</td>
					</tr>
}
				</tbody>
			</table>
}
		</div>
	</div>
</div>
}

@if (!isModalLoading) {
<div class="modal-footer" [hidden]="minimise">
	<button class="save-button" type="button" [disabled]="isViewOnly" (click)="addRow()">Add New Project Tag</button>
	<button class="save-button" type="button" [disabled]="isViewOnly" (click)="saveData()">Save</button>
	<button class="cancel-button" type="button" (click)="modalClose()">Cancel</button>
</div>
}
